(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal2/assets/javascripts/quickplay-modal.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal2/assets/javascripts/quickplay-modal.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  useState,
  useEffect,
  useCallback
} = React;
const {
  useHistory
} = ReactRouterDOM;
const {
  getPixHandler
} = svs.components.sport.pixHandler;
const {
  Modal,
  QuickplayModalHeader,
  QuickplayModalMain,
  QuickplayModalFooter
} = svs.components.sport.quickplayModal2;
const QuickplayModal = _ref => {
  let {
    branding,
    productId,
    drawNumber,
    systemCost,
    rowPrice,
    wallet,
    onModalClose,
    hasPortal,
    isPixMix,
    systemType,
    productSizes,
    competitionBranding,
    redirectToOnPaymentComplete
  } = _ref;
  const history = useHistory();
  const pixHandler = getPixHandler({
    isPixMix
  });
  const [isStillOpen, setIsStillOpen] = useState(true);
  const handleClose = useCallback(() => {
    pixHandler.unsetKeepOpenItem();
    svs.ui.loader.hide();
    setIsStillOpen(false);
    if (onModalClose) {
      onModalClose();
    }
  }, [onModalClose, pixHandler]);
  const handleRedirect = useCallback(() => {
    if (redirectToOnPaymentComplete) {
      history.push(redirectToOnPaymentComplete);
    }
  }, [history, redirectToOnPaymentComplete]);
  const [drawData, setDrawData] = useState();
  const [pixData, setPixData] = useState();
  const [selectedSystemCost, setSelectedSystemCost] = useState(systemCost);
  const refreshPix = useCallback(async (updatedSystemCost, shouldGenerateNewPix) => {
    if (selectedSystemCost !== updatedSystemCost) {
      setSelectedSystemCost(updatedSystemCost);
    } else {
      const {
        drawResponse,
        pixResponse
      } = await svs.components.sport.quickplayModal2.services.fetchDrawAndPix({
        productId,
        drawNumber,
        systemType,
        systemCost: selectedSystemCost,
        rowPrice,
        branding,
        productSizes,
        isPixMix,
        shouldGenerateNewPix
      });
      setDrawData(_objectSpread({}, drawResponse));
      setPixData(_objectSpread({}, pixResponse));
    }
  }, [productId, drawNumber, systemType, selectedSystemCost, rowPrice, branding, productSizes, isPixMix]);
  useEffect(() => {
    refreshPix(selectedSystemCost);
  }, [selectedSystemCost, refreshPix]);
  if (!drawData || !pixData) {
    return null;
  }
  if (!isStillOpen) {
    return null;
  }
  return React.createElement(Modal, {
    ariaLabel: "PIX widget",
    handleCloseModal: handleClose,
    hasPortal: hasPortal,
    initialFocusSelector: ".initial-focus",
    isClosingOnBackgroundClick: true
  }, React.createElement("div", {
    className: "quickplay-modal2 quickplay-modal2-branding-".concat(branding, " fc-white")
  }, React.createElement(QuickplayModalHeader, {
    handleClose: handleClose,
    productId: productId
  }), React.createElement(QuickplayModalMain, {
    branding: branding,
    drawData: drawData,
    isPixMix: isPixMix,
    onRefreshPix: _ref2 => {
      let {
        updatedSystemCost,
        shouldGenerateNewPix
      } = _ref2;
      refreshPix(updatedSystemCost, shouldGenerateNewPix);
    },
    productSizes: productSizes
  }), React.createElement(QuickplayModalFooter, {
    competitionBranding: competitionBranding,
    drawData: drawData,
    handleClose: handleClose,
    handleRedirect: handleRedirect,
    hasSaveButton: isPixMix,
    isPixMix: isPixMix,
    wallet: wallet
  })));
};
QuickplayModal.defaultProps = {
  isPixMix: false
};
setGlobal('svs.components.sport.quickplayModal2.QuickplayModal', QuickplayModal);

 })(window);